// Copyright 2025. WebPros International GmbH. All rights reserved.

import { RootState } from 'client/core/store';
import { UserStatus } from 'common/api/resources/User';

export const isUserLockedOrSuspended = (state: RootState): boolean =>
    [UserStatus.LOCKED, UserStatus.SUSPENDED].includes(state.auth.user.status);